// extracted by mini-css-extract-plugin
export default {"container":"Background_container__TIrwv","filter":"Background_filter__FeeLf","title":"Background_title__WsOU9","subtitle":"Background_subtitle__PdjXD"};